<p-breadcrumb [model]="breadcrumb"></p-breadcrumb>
<h1>Delegation</h1>
<main class="home-delegation">
  <div class="instruction-text">Maintain your approval/submission delegations.</div>

  <h4 style="text-align: center">Approval Delegation</h4>
  <app-data-table *ngIf="delegations&&delegations[DelegationType.Approval]"
                  [columns]="tableColumns" [value]="delegations[DelegationType.Approval].delegates" [disableSearch]="true"
                  sortField="type" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                  [leftCaptionTemplate]="leftCaptionTemplateForApproval" [rightCaptionTemplate]="rightCaptionTemplateForApproval" [bodyTemplate]="bodyTemplateForApproval">

    <ng-template #leftCaptionTemplateForApproval>
      <button pButton type="button" class="icon-action" icon="fa fa-refresh" label="Reload" (click)="getMyDelegation()"></button>
    </ng-template>

    <ng-template #rightCaptionTemplateForApproval>
      <span style="float:left;">
        <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="New Approval Delegation" style="margin-left:15px;"
                (click)="onClickAddDelegate(DelegationType.Approval)">
        </button>
      </span>
      <p-selectButton optionLabel="label" optionValue="value"
                      [options]="stateOptions"
                      [(ngModel)]="delegations[DelegationType.Approval].delegationOn"
                      (onChange)="toggleDelegation($event.value, DelegationType.Approval)"
                      [disabled]="!delegations[DelegationType.Approval].delegates || delegations[DelegationType.Approval].delegates.length==0">
      </p-selectButton>
    </ng-template>

    <ng-template #bodyTemplateForApproval let-row="row" let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" [ngSwitch]="col.field">
          <span class="p-column-title">{{col.header}}</span>
          <span class="p-cell">
            <div *ngSwitchCase="'transaction'">{{row[col.field] | stringReplace: LabelChangeTransactionType: true}}</div>
            <div *ngSwitchCase="'dateFrom'">{{row[col.field] | date: Format.Date}}</div>
            <div *ngSwitchCase="'dateThru'">{{row[col.field] | date: Format.Date}}</div>
            <div *ngSwitchCase="'userSummary.fullName'">{{row['userSummary']?.fullName}}</div>
            <div *ngSwitchCase="'action'">
              <button pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Update Delegation" tooltipPosition="top" (click)="onClickEditDelegate(row, DelegationType.Approval)">
              </button>
              <button pButton type="button" class="icon-negative" icon="fa fa-trash" pTooltip="Delete Delegation" tooltipPosition="top" (click)="deleteDelegate(row, DelegationType.Approval)">
              </button>
            </div>
            <div *ngSwitchDefault>
              <app-data-table-renderer [col]="col" [row]="row"></app-data-table-renderer>
            </div>
          </span>

        </td>
      </tr>
    </ng-template>
  </app-data-table>


  <h4 style="text-align: center">Submission Delegation</h4>
  <app-data-table *ngIf="delegations&&delegations[DelegationType.Submission]"
                  [columns]="tableColumns" [value]="delegations[DelegationType.Submission].delegates" [disableSearch]="true"
                  sortField="type" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                  [rightCaptionTemplate]="rightCaptionTemplateForSubmission" [bodyTemplate]="bodyTemplateForSubmission">

    <ng-template #rightCaptionTemplateForSubmission>
      <span style="float:left;">
        <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="New Submission Delegation" style="margin-left:15px;"
                (click)="onClickAddDelegate(DelegationType.Submission)">
        </button>
      </span>
      <p-selectButton optionLabel="label" optionValue="value"
                      [options]="stateOptions"
                      [(ngModel)]="delegations[DelegationType.Submission].delegationOn"
                      (onChange)="toggleDelegation($event.value, DelegationType.Submission)"
                      [disabled]="!delegations[DelegationType.Submission].delegates || delegations[DelegationType.Submission].delegates.length==0">
      </p-selectButton>
    </ng-template>

    <ng-template #bodyTemplateForSubmission let-row="row" let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" [ngSwitch]="col.field">
          <span class="p-column-title">{{col.header}}</span>
          <span class="p-cell">
            <div *ngSwitchCase="'transaction'">{{row[col.field] | stringReplace: LabelChangeTransactionType: true}}</div>
            <div *ngSwitchCase="'dateFrom'">{{row[col.field] | date: Format.Date}}</div>
            <div *ngSwitchCase="'dateThru'">{{row[col.field] | date: Format.Date}}</div>
            <div *ngSwitchCase="'userSummary.fullName'">{{row['userSummary']?.fullName}}</div>
            <div *ngSwitchCase="'action'">
              <button pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Update Delegation" tooltipPosition="top"
                      (click)="onClickEditDelegate(row, DelegationType.Submission)">
              </button>
              <button pButton type="button" class="icon-negative" icon="fa fa-trash" pTooltip="Delete Delegation" tooltipPosition="top"
                      (click)="deleteDelegate(row, DelegationType.Submission)">
              </button>
            </div>
            <div *ngSwitchDefault>
              <app-data-table-renderer [col]="col" [row]="row"></app-data-table-renderer>
            </div>
          </span>
        </td>
      </tr>
    </ng-template>
  </app-data-table>

  <!-- <p-contextMenu #cm [model]="menuItems[DelegationType.Submission]"></p-contextMenu> -->

  <p-confirmDialog></p-confirmDialog>

  <p-dialog *ngIf="delegate&&displayDialog" [(visible)]="displayDialog"
            header="Delegation Detail" [modal]="true" [dismissableMask]="true" [responsive]="true" [style]="PrimeNgConfig.DialogStyle40">

    <form #dialogForm="ngForm">
      <div>
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Type</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown *ngIf="delegationType===DelegationType.Approval" name="subType" class="form-control" placeholder="Select..."
                        [style]="{'width':'100%'}" [options]="approvalTypeDropdown" [(ngModel)]="delegate.subtype" (onChange)="onChangeDelegateSubtype(delegate)" required></p-dropdown>
            <p-dropdown *ngIf="delegationType===DelegationType.Submission" name="subType" class="form-control" placeholder="Select..."
                        [style]="{'width':'100%'}" [options]="submissionTypeDropdown" [(ngModel)]="delegate.subtype" (onChange)="onChangeDelegateSubtype(delegate)" required></p-dropdown>
          </div>
        </div>

        <div *ngIf="delegate.subtype===DelegationSubType.Transaction" class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Transaction Type</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown name="txnType" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                        [options]="txnTypeDropdown"
                        [(ngModel)]="delegate.transaction" required>
            </p-dropdown>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Delegate</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-autoComplete name="delegate" class="autoComplete" field="fullName" [minLength]="Validation.AutoCompleteMinLength"
                            [placeholder]="Validation.AutoCompletePlaceholder" [showEmptyMessage]="true" [suggestions]="suggestedDelegates"
                            [(ngModel)]="delegate.userSummary"
                            (completeMethod)="searchDelegate($event, delegationType, delegate.subtype)" (onSelect)="delegate.userId=delegate.userSummary.id"
                            [disabled]="!delegate.subtype" required>
            </p-autoComplete>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Start Date</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-calendar name="startDate" dataType="string" [dateFormat]="Format.PcalendarDate" [minDate]="minDateFrom" [showIcon]="true"
                        [(ngModel)]="delegate.dateFrom" (onSelect)="onSelectDateFrom(delegate)" [disabled]="!delegate.subtype" required></p-calendar>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>End Date</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-calendar name="endDate" dataType="string" [dateFormat]="Format.PcalendarDate" [minDate]="minDateThru" [showIcon]="true" [(ngModel)]="delegate.dateThru"
                        [disabled]="!delegate.subtype" required></p-calendar>
          </div>
        </div>
      </div>
    </form>

    <p-footer>
      <div class="p-col-12" style="text-align:right;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="cancel()"></button>
        <button *ngIf="newDelegate" pButton type="button" class="button-action" icon="fa fa-check" label="Add" (click)="addDelegate(delegate, delegationType)"
                [disabled]="!dialogForm.form.valid"></button>
        <button *ngIf="!newDelegate" pButton type="button" class="button-action" icon="fa fa-check" label="Update" (click)="updateDelegate(delegate, delegationType)"></button>

      </div>
      <div class="main-clear"></div>
    </p-footer>

  </p-dialog>
  <div class="main-clear">&nbsp;</div>
</main>
